<template>
  <div>
    <!-- Popup para cuando no se quiera mostrar el Catálogo -->
    <div
      class="modal fade"
      id="modalPopup"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div style="margin:auto">
          <div id="boton" class="boton">
            <button
              type="button"
              class="close close-info-l"
              data-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div class="row justify-content-center">
            <img alt="popup" width="100%" :src="imgSinCatalogue">
          </div>
        </div>
      </div>
    </div>
    <nav class="navbar fixed-top navbar-expand-lg navbar-light bg-light navbar-light bg-light">
      <div class="container-img">
        <img style="cursor: pointer" @click="profile()" width="114" height="30" src="./../assets/icon/hav_logo.svg"
          class="img-navbar" title="logo havoline moto club" alt="logo havoline moto club"/>
      </div>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto"></ul>
        <div class="form-inline  my-2 my-lg-0 ">
          <ul class="navbar-nav mx-auto">
            <!-- Catálogo para usuarios de rol Puntos de venta -->
            <template v-if="rol == 2">
              <router-link 
                to="/app/punto-de-venta/catalogo"
                :class="{
                  active: $route.name === 'cataloguePOS',
                  'nav-item': true,
                  'nav-link': true,
                  'mx-2': true
                }"
              >
                <span style="padding:10px" @click.prevent="Catalogue()">Catálogo</span>
              </router-link>
            </template>

            <template v-for="(item,i) in itemMenu">
              <router-link v-if="item.subItem.length == 0" :key="item.id" :style="item.style"
                :to="{ name: item.routeName, params: { section: 1 } }" :class="{
                  active: $route.name === item.routeName,
                  'nav-item': true,
                  'nav-link': true
                }">
                <i v-if="item.icon" class="fa fa-shopping-cart " aria-hidden="true"><span
                    class="badge badge-pill badge-danger ml-1 itemCard">{{productCard}}</span></i>
                <span v-else @click="ocultar">{{ item.text }}</span>
                <template v-if="item.name == true"> <span @click="ocultar">{{ dataUser }}</span></template>
              </router-link>

              <li v-else class="nav-item dropdown" :key="i">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  {{item.text}}
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">

                  <router-link v-for="data in item.subItem " :key="data.id" class="dropdown-item text-danger"
                    :to="{ name: data.routeName }" :class="{
                      active: $route.name === data.routeName,
                      'nav-item': true,
                      'nav-link': true
                    }">
                    <span @click="ocultar">{{ data.text }}</span>
                  </router-link>
                </div>
              </li>
            </template>

            <!-- Categorías de alianzas -->
            <template v-if="categories.length > 0 && (rol == 4 || rol == 5)">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  Alianzas
                </a>
                <div style="margin-bottom:20px;" class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <router-link v-for="data in categories" :key="data.id" class="dropdown-item text-danger"
                    :to="{ name: 'alliances1', params: { name: data.name } }" :class="{
                      active: $route.name === data.name,
                      'nav-item': true,
                      'nav-link': true
                    }">
                    <span @click="ocultar">{{ data.name }}</span>
                  </router-link>
                </div>
              </li>
            </template>

            <template v-if="rol == 4 || rol == 5">
              <router-link 
                to="/app/user/catalogo"
                :class="{
                  active: $route.name === 'catalogue1',
                  'nav-item': true,
                  'nav-link': true,
                  'mx-2': true
                }"
              >
                <span style="padding:10px" @click.prevent="Catalogue()">Catálogo</span>
              </router-link>
            </template>

            <template v-for="(item,i) in itemMenu2">
              <router-link v-if="item.subItem.length == 0" :key="item.id"
                :to="{ name: item.routeName, params: { section: 1 } }" :class="{
                  active: $route.name === item.routeName,
                  'nav-item': true,
                  'nav-link': true
                }">
                <i v-if="item.icon" class="fa fa-shopping-cart " aria-hidden="true"><span
                    class="badge badge-pill badge-danger ml-1 itemCard">{{productCard}}</span></i>
                <span v-else @click="ocultar">{{ item.text }}</span>
                <template v-if="item.name == true"> <span @click="ocultar">{{ dataUser }}</span></template>
              </router-link>

              <li v-else class="nav-item dropdown" :key="i">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  {{item.text}}
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">

                  <router-link v-for="data in item.subItem " :key="data.id" class="dropdown-item text-danger"
                    :to="{ name: data.routeName }" :class="{
                      active: $route.name === data.routeName,
                      'nav-item': true,
                      'nav-link': true
                    }">
                    <span @click="ocultar">{{ data.text }}</span>
                  </router-link>
                </div>
              </li>
            </template>

            <!-- <template v-if="rol === 1">
              <div
                  class=""
                  style="text-align: center"
                >
                  <button
                    @click="goLottery()"
                    class="btn btn-danger btn-block" style="padding: .3rem;font-size: 0.775rem;line-height: 1.5;border-radius: .2rem;"
                  >
                    <b>SORTEO</b>
                  </button>
                </div>
            </template> -->
            <template v-if="rol == 1">
              <div v-if="loading" class="spinner-border text-danger mt-2" role="status" style="width: 1.5rem; height: 1.5rem;">
                <span class="sr-only">Loading...</span>
              </div>
              <!-- <a v-else-if="rol !== 9" @click="reportes()" :key="5" class="nav-item nav-link" style="cursor: pointer">
                Reporte de compras
              </a> -->
              <a @click="irStock()" :key="6" class="nav-item nav-link" style="cursor: pointer">
                Reporte de Stock
              </a>
            </template>

            <template v-if="rol == 8">
              <a @click="irProducts()" :key="4" class="nav-item nav-link" style="cursor: pointer">
                Lista de productos
              </a>
              <div v-if="loading" class="spinner-border text-danger mt-2" role="status" style="width: 1.5rem; height: 1.5rem;">
                <span class="sr-only">Loading...</span>
              </div>
              <!-- <a v-else @click="reportShopping()" :key="5" class="nav-item nav-link" style="cursor: pointer">
                Reportes de compras
              </a> -->
              <a @click="irStock()" :key="6" class="nav-item nav-link" style="cursor: pointer">
                Reporte de Stock
              </a>
            </template>

            <div v-for="item in itemMenuRight" :key="item.id">
              <a @click="cerrar()" class="nav-item nav-link" style="cursor: pointer">
                <i class="fa fa-sign-out fa-lg icon-style-nav text-danger" aria-hidden="true"></i>
              </a>
            </div>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
  import {logout} from "@/config/auth";
  import {navigation} from "./navigationRole";
  import $ from 'jquery';
  import {mapState, mapMutations} from "vuex";
  import axios from "axios";

  export default {
    name: "navbarUser",
    computed: {
      ...mapState(["productCard"])
    },
    data() {
      return {
        dataUser: "",
        rol: "",
        itemMenu: [],
        itemMenu2: [],
        loading: false,
        itemMenuRight: [
          {
            id: 4,
            routeName: "logout",
            text: "Cerrar sesión",
            count: true,
            action: function () {
              logout();
            }
          }
        ],
        popups: [],
        imgSinCatalogue: null,
        flagCatalogue: false,
        arrayCategories: [],
        categories: [],
      };
    },
    methods: {
      Catalogue(){
        if(this.flagCatalogue == true){
          $('#modalPopup').modal('show');
        } else {
          if(this.rol == 2){
            this.$router.push({name: "cataloguePOS"});
          } else {
            this.$router.push({name: "catalogue1"});
          }
        }
      },
      getListCard() {
        let app = this;
        axios.get("superAdmin/commerce/getShoppingCart")
          .then((res) => {
            if (res.data.cod == 0) {
              app.$store.commit("totalPoints", res.data.data.length);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      ocultar() {
        var navMain = $("#navbarSupportedContent");
        navMain.collapse('hide');
      },
      inicio() {
        this.$router.push({name: "landingPage"});
        var navMain = $("#navbarSupportedContent");
        navMain.collapse('hide');
      },
      profile() {
        var rol = sessionStorage.getItem("dXNlclJvbGU=");
        var rolde = atob(rol);
        switch (parseInt(rolde)) {
          case 2:
            this.$router.push({name: "pointOfsaleProfile" });
            break;
          case 4:
            this.$router.push({name: "lubricatorProfile" });
            break;
          case 6:
            this.$router.push({name: "comercialProfile"});
            break;
          case 9:
            this.$router.push({ name: "coljuegosProfile" });
          break;
          default:
            this.$router.push({name: "profileUser"});
          break;
        }
        var navMain = $("#navbarSupportedContent");
        navMain.collapse('hide');
      },
      cerrar() {
        logout();
        this.$router.push({ name: "home" });
      },
      reportes() {
        this.loading = true;
        var app = this;
        axios
          .get("superAdmin/report/sales/all")
          .then(function (res) {
            if (res.data.ResponseCode == 0) {
              var link = document.createElement("a");
              link.setAttribute("href", res.data.ResponseMessage);
              link.setAttribute("download", "Reportes.csv");
              document.body.appendChild(link);
              link.click();
            }
            app.loading = false;
          })
          .catch(function (error) {
            app.loading = false;
            console.log(error);
          });
      },
      // reportes() {
      //   this.loading = true;
      //   var app = this;
      //   axios
      //     .get("superAdmin/reports")
      //     .then(function (res) {
      //       if (res.data.ResponseCode == 0) {
      //         var link = document.createElement("a");
      //         link.setAttribute("href", res.data.ResponseMessage);
      //         link.setAttribute("download", "Reportes.csv");
      //         document.body.appendChild(link);
      //         link.click();
      //       }
      //       app.loading = false;
      //     })
      //     .catch(function (error) {
      //       app.loading = false;
      //       console.log(error);
      //     });
      // },
      goLottery(){
        this.$router.push({name: "adminLottery"});
      },
       goWinners(){
        this.$router.push({name: "coljuegosProfile"});
      },
      irProducts(){
        this.$router.push({name: "productoMotoMercado"});
        var navMain = $("#navbarSupportedContent");
        navMain.collapse('hide');
      },
      irStock(){
        this.$router.push({name: "listStock"});
        var navMain = $("#navbarSupportedContent");
        navMain.collapse('hide');
      },
      reportShopping() {
        this.loading = true;
        var app = this;
        axios
          .get("superAdmin/reportShopping")
          .then(function (res) {
            if (res.data.ResponseCode == 0) {
              var link = document.createElement("a");
              link.setAttribute("href", res.data.ResponseMessage);
              link.setAttribute("download", "Reportes.csv");
              document.body.appendChild(link);
              link.click();
            }
            app.loading = false;
          })
          .catch(function (error) {
            app.loading = false;
            console.log(error);
          });
      },
      getDataUser() {
        // console.log("entra");
        var app = this;
        axios
          .get("api/showUser")
          .then(function (res) {
              if(res.data.User.document_number != null){
                app.menu();
              }
              var name = "";
              var lastN = "";
              if(res.data.User.name != null){
                name = res.data.User.name ;
              } 
              if(res.data.User.last_name != null){
                lastN = res.data.User.last_name;
              } 
              app.dataUser = ' ' + name + " " + lastN;
              app.rol = res.data.User.role_id;
              // console.log(res.data.User.role_id + " Aquii");
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      menu() {
        var rol = sessionStorage.getItem("dXNlclJvbGU=");
        var rolde = atob(rol);
        let menu = [];
        let menu2 = [];
        switch (parseInt(rolde)) {
          case 1:
            menu = navigation.userAdmin;
            break;
          case 2:
            menu = navigation.userPointOfSale;
            break;
          case 3:
            menu = navigation.userAdminCrm;
            break;
          case 4:
            menu = navigation.userLibricator;
            menu2 = navigation.userLibricator2;
            break;
          case 5:
            menu = navigation.userShop;
            menu2 = navigation.userShop2;
            break;
          case 6:
            menu = navigation.userComercial;
            break;
            // case 8:
            // menu = navigation.userShop;
            // break;
          default:
            break;
        }
        this.itemMenu = menu;
        this.itemMenu2 = menu2;
      },
      getBanners(){
        axios
        .get("api/files/histories/6")
        .then(res => {
          if (res.data.cod == 0) {
            this.popups = res.data.data;
            this.popups.forEach(popup => {
              if(popup.location == 2 && popup.status_id == 1){
                this.imgSinCatalogue = popup.url;
                this.flagCatalogue = true;
                // console.log('this.imgSinCatalogue ', JSON.stringify(this.imgSinCatalogue));
              }
            });
          }
        })
        .catch(error => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
      },
      getCategories(){
        let app = this;
        axios
        .get("api/get/categories")
        .then(res => {
          app.arrayCategories = res.data.data;
          app.categories = app.arrayCategories.filter(element => element.status_id == 1);
        })
        .catch(error => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
      },
    },
    // created() {
    //   this.menu();
    // },
    mounted() {
      this.getListCard();
      this.getDataUser();
      this.getBanners();
      this.getCategories();
      // var urlActual = window.location.href;
      // var url = urlActual.split('/');
      // if(url[5] == 'catalogo'){
      //   this.$router.push({ name: "profileUser" });
      //   $('#modalPopup').modal('show');
      // }
    }
  };
</script>

<style scope>
  .dropdown-item.active {
    background-color: #007bff00;
    color: #1da5df !important;
  }

  .itemCard {
    padding: 0.2rem !important;
  }

  /* .fa{
    color: #dc3545 !important;
  } */

  .fa .icon-style {
    font-size: 25px;
    color: #dc3545 !important;
    padding: 6px;
  }

  .icon-card {
    color: #dc3545 !important;
  }

  .navbarProfile {
    background-color: #000000b8 !important;
  }

  .container-img {
    margin: 0%;
  }

  .navbar {
    background-color: #fff !important;
    /* padding: 0rem 0rem !important; */
  }

  .btn-sm-nav {
    height: 37px;
  }

  .navbar-light .navbar-nav .nav-link {
    font-size: 13px !important;
    color: #dc3545;
    font-weight: bold;
  }

  /* Cuando está active */

  .navbar-light .navbar-nav .nav-link.active,
  .navbar-light .navbar-nav .nav-link.show,
  .navbar-light .navbar-nav .show>.nav-link {
    /* border: solid 2px brown; */
    color: #1da5df;
    /* height: 35px !important;
    padding-top: 2px !important; */
  }

  /* TABLET */
  @media (max-width: 1023px) {
    .dropdown-menu {
      border-color: white !important;
      text-align: center;
    }
  }

  /* MOBILE */
  @media (max-width: 767px) {
    .dropdown-menu {
      border-color: white !important;
      text-align: center;
    }

    .navbar {
      background-color: white !important;
      padding: 0.5rem 1rem !important;
    }

    .icon-network1-instagram {
      margin-top: 5px;
      margin-left: 0px;
    }
    .padding-button {
      padding-left: 5px !important;
      padding-right: 5px  !important;
    }

    /* .img-navbar {
      content: url("./../assets/LogoMenu.png");
    } */
  }
  #modalPopup{
    position: fixed;
    z-index: 10000;
    /* max-width: 80%;
    max-height: 80%; */
    margin: auto !important;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  #boton{
    margin: -10px 0px 15px 0px;
    background-color: white;
    color: #dc3545;
  }
</style>